export interface TourStep {
  label: string;
  completed: boolean;
  optional: boolean;
  error: string | undefined;
}

export const FIELD_STEPS: TourStep[] = [
  {
    label: "Appointment",
    completed: false,
    optional: false,
    error: undefined,
  },
  {
    label: "Review and Submit",
    completed: false,
    optional: false,
    error: undefined,
  },
  {
    label: "Confirmed Bookings",
    completed: false,
    optional: true,
    error: "Guest email must be provided",
  },
];

export const DEFAULT_STEPS: TourStep[] = [
  {
    label: "Appointment",
    completed: false,
    optional: false,
    error: undefined,
  },
  {
    label: "Guest",
    completed: false,
    optional: false,
    error: undefined,
  },
  {
    label: "Review and Submit",
    completed: false,
    optional: false,
    error: undefined,
  },
  {
    label: "Confirmed Bookings",
    completed: false,
    optional: true,
    error: "Guest email must be provided",
  },
];
